export default () => {
    const footer = document.getElementById("footer");
    import(/* webpackChunkName: "footer" */ "./../classes/footerClass")
        .then(({ default: Footer }) => {
        new Footer(footer);
    })
        .catch(() => "An error with footer occurred");
};
